// Dados frescos no celular, no campo.
//
// O `queryClient` global é `staleTime: Infinity`, `refetchOnWindowFocus: false`,
// `retry: false` — certo para Cacho/Equipe, errado para quem alterna entre o
// WhatsApp e o app e precisa ver o que mudou. Estas opções valem SÓ nas consultas do
// Manejo (lista, minhas, semana, detalhe); o global não muda.

export const OPCOES_CONSULTA_FRESCA = {
  staleTime: 30_000,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  retry: 2,
} as const;

/** 1 s, depois 3 s (e 3 s nas seguintes) — sinal fraco costuma voltar logo. */
export function atrasoDeNovaTentativa(tentativa: number): number {
  return tentativa <= 0 ? 1000 : 3000;
}

export const CONSULTA_FRESCA = { ...OPCOES_CONSULTA_FRESCA, retryDelay: atrasoDeNovaTentativa } as const;
